/* src/app/shared/components/ag-report/ag-report.component.scss */
div {
  font-size: 1rem;
  border-bottom: 1px solid #c8c7cc;
  align-items: center;
  height: 50px;
}
div .remarks-arrow {
  padding-right: 16px;
  display: flex;
  justify-content: flex-end;
}
div .remark-status {
  width: 31px;
}
div .remark-status img {
  height: 27px;
}
div:first-of-type {
  border-top: 1px solid #c8c7cc;
  font-weight: bold;
  cursor: pointer;
}
.ag-success {
  color: #578a6b;
}
.ag-info {
  color: #333333;
}
.ag-warning {
  color: #e4be5e;
}
.ag-error {
  color: #d7263c;
}
/*# sourceMappingURL=ag-report.component.css.map */
